var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10"},[_c('v-expansion-panels',{attrs:{"flat":""}},[(_vm.canView('mvtipoempleado'))?_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('p',{staticClass:"primary--text text-h6"},[_vm._v("Tipos de empleado")])]),_c('v-expansion-panel-content',[_c('kn-employee-types')],1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }